export default "https://ssr-releases-cdn.paperlesspost.com/_next/static/video/tile_kidsbirthday-b20bc0e20fceb0d8abe683fd8a44a1bc.jpg";